export default class BaseDTO {

    public id: number = 0;
    public createdAt: string = '';
    public updatedAt: string = '';
    public createdBy: string = '';
    public updatedBy: string = '';
    public version: number = 0;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'];
        this.createdAt = data['createdAt'];
        this.updatedAt = data['updatedAt'];
        this.createdBy = data['createdBy'];
        this.updatedBy = data['updatedBy'];
        this.version = data['version'];
    }

}